import { Patch } from 'immer';
import { SnapshotType } from '../../../sheet/databaseDeprecated/types';
import {
  GlobalDatabases,
  getGlobalDatabaseInstance,
} from '../manager/databaseManager';
import { UnSyncedStores } from '../schemas/pendingQueueSchema';

export enum UnSyncedRecordType {
  SheetsRoot = 'SheetsRoot',
  //   CalculateResults
}

export type UnSyncedRecord =
  | {
      type: SnapshotType;
      id: string;
      activeWAL: number;
      localSerial: number;
    }
  | {
      type: UnSyncedRecordType.SheetsRoot;
      changes: Patch[];
    };
// TODO: Add Calculate results type => it will not be saved in normal wal as this part is only needed by the server or the parent machine that contains
// all the sheets to calculate results
// It is a separate wal that will be generated by if independent cell is changed and dependent sheet is not found

export const saveRecordInUnSyncedDB = async (record: UnSyncedRecord) => {
  const db = await getGlobalDatabaseInstance(
    GlobalDatabases.UnSynced,
    GlobalDatabases.UnSynced
  );

  await db.table(UnSyncedStores.Records).put(record);
};
